import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";

import { AttendancesState } from "@reducers/types/HRM/attendances-state";

import { getAttendancesRequest } from "@actions/HRM/attendances/attendances-actions";
import { attendancesState } from "@selectors/HRM/attendance/attendances-selector";

import { useAppSelector } from "@helpers/redux";

interface UseAttendances {
  attendances: any;
  pagination: any;
  handleQuery: (key: string, value: any) => void;
  queryParams: any;
}

export const useAttendances = (): UseAttendances => {
  const localizedFormat = require("dayjs/plugin/localizedFormat");
  dayjs.extend(localizedFormat);

  const [query, setQuery] = useState({
    page: 1,
    size: 10,
    date: dayjs(new Date()).format("YYYY-MM-DD"),
    attendanceStatusID: "",
  });

  const handleQuery = (key: string, value: any) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  const { data } = useAppSelector<AttendancesState>(attendancesState);

  const { data: attendances, pagination } = data || ({} as any);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAttendancesRequest(query));
  }, [dispatch, query]);

  return {
    attendances,
    handleQuery,
    pagination,
    queryParams: query,
  };
};
